//微信定位
var config = require("../config");
var util = require("../util");
var urlDebug = ~location.href.indexOf("debug:whereami");

var isInWeixin = function () {
    return /MicroMessenger/.test(navigator.userAgent);
};

module.exports = function (suc, fail, next) {
    if (!isInWeixin()) {
        next();
    } else {
        var wxGeo = function () {
            if (typeof wx === "undefined") {
                next();
                return;
            }
            wx.ready(function () {
                wx.checkJsApi({
                    jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function (res) {
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                        if (res.checkResult && res.checkResult.getLocation) {
                            wx.getLocation({
                                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                                success: function (res) {
                                    suc({
                                        lat: res.latitude,
                                        lng: res.longitude
                                    });
                                },
                                fail: fail
                            });
                        } else {
                            next();
                        }
                    },
                    fail: next
                });


            });
        };

        if (config.get("wxAutoConfig") && typeof wx === "undefined") {
            require.ensure([], function (require) {
                var loader = require("@dp/weixin-js-sdk-loader");
                loader.use(wxGeo);
            });

        } else {
            wxGeo();
        }
    }
};

module.exports.type = "weixin";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/weixin.js